module.exports = __webpack_public_path__ + "img/cloth_g3_item-01.59384ad8.svg";